
import React, { useEffect, useRef } from "react";

const IDEsSection = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Only run in browser environment
    if (typeof window === 'undefined') return;
    
    function scrollToLeft() {
      if (scrollRef.current) {
        scrollRef.current.scrollLeft = 0;
      }
    }

    scrollToLeft();

    // Optional: On window resize, if on mobile, scroll left again
    function handleResize() {
      if (window.innerWidth < 768) {
        scrollToLeft();
      }
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="section-padding bg-coderide-black text-white">
      <div className="container">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-4 flex items-center justify-center">
          <span>Supported IDEs and Clients</span>
        </h2>
        <p className="text-center mb-12 text-white/70">
          Use CodeRide with your <strong className="font-semibold text-white/90">favorite development environments</strong>.
        </p>

        <div
          ref={scrollRef}
          className="flex justify-start items-center gap-8 md:gap-12 lg:gap-16 flex-nowrap overflow-x-auto py-4 max-w-full mx-auto px-6 md:px-0 md:justify-center"
        >
          <div className="text-center flex flex-col items-center flex-shrink-0">
            <img
              src="https://ideybnueizkxwqmjowpy.supabase.co/storage/v1/object/sign/coderide-website/cursor.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJjb2RlcmlkZS13ZWJzaXRlL2N1cnNvci5wbmciLCJpYXQiOjE3NDQ4MTM4OTAsImV4cCI6MTc3NjM0OTg5MH0.pTP_tJOiJPw6kkfgsIP3w2YuIUPijpX1B_iDBxe90Qc"
              alt="Cursor logo"
              className="h-20 w-20 object-contain"
              loading="lazy"
            />
            <span className="text-lg font-medium mt-3">Cursor</span>
          </div>

          <div className="text-center flex flex-col items-center flex-shrink-0">
            <img
              src="https://ideybnueizkxwqmjowpy.supabase.co/storage/v1/object/sign/coderide-website/windsurf-white-symbol.svg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9jOTljZjI2OC04OTEzLTRhYjktYmI4YS0yMTE1MjQ2YzRjNjQiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJjb2RlcmlkZS13ZWJzaXRlL3dpbmRzdXJmLXdoaXRlLXN5bWJvbC5zdmciLCJpYXQiOjE3NjI5MzY4MDYsImV4cCI6MjgwMzYyNDgwNn0.aCXaUgSTlGVLvgJjPFWqLT0jOaNMFCax3vE42IXWjJg"
              alt="Windsurf logo"
              className="h-20 w-20 object-contain"
              loading="lazy"
            />
            <span className="text-lg font-medium mt-3">Windsurf</span>
          </div>

          <div className="text-center flex flex-col items-center flex-shrink-0">
            <div className="flex items-center justify-center h-20 w-20 space-x-2">
              <img
                src="https://ideybnueizkxwqmjowpy.supabase.co/storage/v1/object/sign/coderide-website/Visual_Studio_Code_1.35_icon.svg.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJjb2RlcmlkZS13ZWJzaXRlL1Zpc3VhbF9TdHVkaW9fQ29kZV8xLjM1X2ljb24uc3ZnLnBuZyIsImlhdCI6MTc0NDgwMTgwNywiZXhwIjoxNzc2MzM3ODA3fQ.gK87ziBf8qZ-0kdaIFgiiK0KnBi0dUOkShV0ojhTRlE"
                alt="VS Code logo"
                className="h-12 w-12 object-contain"
                loading="lazy"
              />
              <span className="text-2xl font-medium text-coderide-light-blue">+</span>
              <img
                src="https://ideybnueizkxwqmjowpy.supabase.co/storage/v1/object/sign/coderide-website/cline%20logo_favicon-256x256.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJjb2RlcmlkZS13ZWJzaXRlL2NsaW5lIGxvZ29fZmF2aWNvbi0yNTZ4MjU2LnBuZyIsImlhdCI6MTc0NDgwMjA3NCwiZXhwIjoxNzc2MzM4MDc0fQ.6qE_SdHQu6zh5suwojsSSCbs7uXBg-STY9CNmM1KZ5A"
                alt="Cline logo"
                className="h-12 w-12 object-contain"
                loading="lazy"
              />
            </div>
            <span className="text-lg font-medium mt-3">VS Code + Cline</span>
          </div>

          <div className="text-center flex flex-col items-center flex-shrink-0">
            <img
              src="https://ideybnueizkxwqmjowpy.supabase.co/storage/v1/object/sign/coderide-website/claude-color.svg?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJjb2RlcmlkZS13ZWJzaXRlL2NsYXVkZS1jb2xvci5zdmciLCJpYXQiOjE3NDQ4MTUyMzMsImV4cCI6MTc3NjM1MTIzM30.zgWIB1ohcJBU33U-LNsYLAd79tnI9PhEw1Auw-s3Rpc"
              alt="Claude logo"
              className="h-20 w-20 object-contain"
              loading="lazy"
            />
            <span className="text-lg font-medium mt-3">Claude</span>
          </div>

          <div className="text-center flex flex-col items-center flex-shrink-0">
            <img
              src="https://ideybnueizkxwqmjowpy.supabase.co/storage/v1/object/sign/coderide-website/github-copilot1720909346.webp?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJjb2RlcmlkZS13ZWJzaXRlL2dpdGh1Yi1jb3BpbG90MTcyMDkwOTM0Ni53ZWJwIiwiaWF0IjoxNzQ1MDYxNTI2LCJleHAiOjE3NzY1OTc1MjZ9.TzMB69ic4gX808UhAKokRq4x3CStEn-khFgmgHcCu0c"
              alt="GitHub Copilot logo"
              className="h-20 w-20 object-contain"
              loading="lazy"
            />
            <span className="text-lg font-medium mt-3">GitHub Copilot</span>
          </div>
        </div>
      </div>
    </section>
  );
};
export default IDEsSection;
